import { SidePanel, SidePanelSheetSkeleton } from '@gitbook/react-uikit';
import { HeaderBarSkeleton } from '@gitbook/spine-react';

import { SpaceContentSkeleton } from './SpaceContentSkeleton';

/**
 * Skeleton of the entire space screen.
 */
export function SpaceScreenSkeleton(props: { withSidePanel: boolean }) {
    const { withSidePanel } = props;

    return (
        <SidePanel
            sidePanel={
                withSidePanel
                    ? {
                          children: <SidePanelSheetSkeleton />,
                      }
                    : null
            }
            animationKey="skeleton"
        >
            <div className="flex flex-1 flex-col">
                <HeaderBarSkeleton />
                <SpaceContentSkeleton />
            </div>
        </SidePanel>
    );
}
